const endPoints = {
  loginAdmin: 'api/v1/admin/login',
  sendOtp: 'api/v1/admin/forgetPassword',
  resetPassword: id => `api/v1/admin/resetPassword/${id}`,
  createSubAdmin: 'api/v1/admin/sub-admin',
  getSubAdmins: 'api/v1/admin/sub-admin',
  deleteSubAdmin: id => `api/v1/admin/sub-admin/${id}`,
  getWithdrawalWindow: 'api/v1/admin/withdrawal-window',
  updateWithdrawalWindow: 'api/v1/admin/withdrawal-window',
  getallcategory: 'api/v1/admin/Category/allCategory',
  getalluserwithoutpagi: 'api/v1/profile/AllActiveUser',
  getallcategoryPaginate: (page, limit, search) =>
    `api/v1/admin/Category/paginateCategorySearch?search=${
      search ? search : ''
    }&page=${page}&limit=${limit}`,
  getallsubcategory: 'api/v1/SubCategory/all/SubCategoryForAdmin',
  getallsubcategorybycategory: id => `api/v1/SubCategory/allSubcategoryById/${id}`,
  getallsubcategoryPaginate: (page, limit, search) =>
    `api/v1/SubCategory/paginate/SubCategoriesSearch?search=${
      search ? search : ''
    }&page=${page}&limit=${limit}`,
  getallsubcategorychild: 'api/v1/SubCategoryChild/all/SubCategoryChildForAdmin',
  getallsubcategorychildbycategory: (Categoryid, subcategoryid) =>
    `api/v1/SubCategoryChild/all/SubCategoryChildForAdmin?categoryId=${Categoryid}&subCategoryId=${subcategoryid}`,
  getallsubcategorychildPaginate: (page, limit, search) =>
    `api/v1/SubCategoryChild/paginate/SubCategoryChildSearch?search=${
      search ? search : ''
    }&page=${page}&limit=${limit}`,
  getallproducts: 'api/v1/Product/all/ProductForAdmin',
  getallproductsPaginate: (page, limit, search) =>
    `api/v1/Product/paginate/ProductSearch?search=${
      search ? search : ''
    }&page=${page}&limit=${limit}`,
  getalluser: (page, limit, search) =>
    `api/v1/profile/AllRegisteredUser?search=${search ? search : ''}&page=${page}&limit=${limit}`,
  getallRegisteredStaff: (page, limit, search, fromDate, toDate) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    if (search) params.set('search', search);
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    return `api/v1/profile/AllRegisteredStaff?${params.toString()}`;
  },
  getStaffWalletTransactions: (staffId, page, limit, fromDate, toDate, type) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    if (type) params.set('type', type);
    return `api/v1/admin/staff-wallet-transactions/${staffId}?${params.toString()}`;
  },
  getAllStaffWalletTransactions: (page, limit, search, fromDate, toDate, type) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    params.set('search', search || '');
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    if (type) params.set('type', type);
    return `api/v1/admin/staff-wallet-transactions?${params.toString()}`;
  },
  getStaffDueSummary: search => {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    return `api/v1/admin/staff-due-summary${params.toString() ? `?${params.toString()}` : ''}`;
  },
  getStaffPenalties: ({
    page = 1,
    limit = 10,
    search,
    code,
    deducted,
    skipReason,
    jobStatus,
    status,
    fromDate,
    toDate,
    deductedFromDate,
    deductedToDate,
    staffId,
    bookingId,
    staffBookingId,
  } = {}) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    if (search) params.set('search', search);
    if (code) params.set('code', code);
    if (deducted !== undefined && deducted !== '') params.set('deducted', deducted);
    if (skipReason) params.set('skipReason', skipReason);
    if (jobStatus) params.set('jobStatus', jobStatus);
    if (status) params.set('status', status);
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    if (deductedFromDate) params.set('deductedFromDate', deductedFromDate);
    if (deductedToDate) params.set('deductedToDate', deductedToDate);
    if (staffId) params.set('staffId', staffId);
    if (bookingId) params.set('bookingId', bookingId);
    if (staffBookingId) params.set('staffBookingId', staffBookingId);
    return `api/v1/admin/staff-penalties?${params.toString()}`;
  },
  getallActivestaff: (page, limit, search) =>
    `api/v1/profile/AllActiveStaff?search=${search ? search : ''}&page=${page}&limit=${limit}`,
  getallorder: (page, limit, search, jobStatus) =>
    `api/v1/admin/getAllBooking?search=${
      search ? search : ''
    }&page=${page}&limit=${limit}&jobStatus=${jobStatus ? jobStatus : ''}`,
  getallstaff: 'api/v1/profile/getAllStaff',
  getallstaffbysubcategory: (subcategoryIds = []) => {
    const query = subcategoryIds.map(id => `subcategoryId[]=${encodeURIComponent(id)}`).join('&');
    return `api/v1/profile/getAllStaff?${query}`;
  },

  getallcoupon: status => `api/v1/admin/getAllcoupan?status=${status ? status : ''}`,
  getallbanner: status => `api/v1/Banner?status=${status ? status : ''}`,
  getallfaq: status => `api/v1/static/faq/All?status=${status ? status : ''}`,
  getalltimesheet: (page, limit, search, jobStatus) =>
    `api/v1/admin/getAllStaffBooking?search=${search ? search : ''}&jobStatus=${
      jobStatus ? jobStatus : ''
    }&page=${page}&limit=${limit}`,
  getprivacypolicy: 'api/v1/static/getPrivacy',
  gettermsCondition: 'api/v1/static/getTerms',
  getcancelpolicy: 'api/v1/static/getCancelPolicy',
  getwallet: (page, limit, { status, paymentType, transactionType, category } = {}) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    if (status) params.set('status', status);
    if (paymentType) params.set('paymentType', paymentType);
    if (transactionType) params.set('transactionType', transactionType);
    if (category) params.set('category', category);
    return `api/v1/profile/allTransactionUser?${params.toString()}`;
  },
  downloadPendingTransactions: (fromDate, toDate) => {
    const params = new URLSearchParams();
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    const query = params.toString();
    return `api/v1/admin/pending-transactions/download${query ? `?${query}` : ''}`;
  },
  updatePendingTransactionStatus: 'api/v1/admin/pending-transactions/update-status',
  refundPendingTransaction: 'api/v1/admin/pending-transactions/refund',
  getContactDetails: appType => `api/v1/viewContactDetails?appType=${appType ? appType : ''}`,
  getContactDetailsOffice: 'api/v1/viewContactDetailsOffice',
  getallcommission: 'api/v1/commission',
  getallvideos: 'api/v1/admin/TrainingVideo/allTrainingVideo',
  getprofile: 'api/v1/user/getProfile',
  getnotification: 'api/v1/notifications/All',
  getdashboardtotal: 'api/v1/profile/dashboard',
  getalldress1: 'api/v1/admin/Dress/allDress',
  getalldress: (page, limit, search) =>
    `api/v1/admin/Dress/paginateDressSearch?search=${
      search ? search : ''
    }&page=${page}&limit=${limit}`,

  getallUserOrders: (page, limit, search, userid, jobStatus) =>
    `api/v1/admin/getAllBooking?search=${
      search ? search : ''
    }&page=${page}&limit=${limit}&user=${userid}&jobStatus=${jobStatus ? jobStatus : ''}`,

  getallChart: period => `api/v1/profile/annualRevenue?period=${period ? period : ''}`,

  getDownloadtimesheet: (fromDate, toDate) =>
    `api/v1/downloadStaffBooking?fromDate=${fromDate ? fromDate : ''}&toDate=${
      toDate ? toDate : ''
    }`,

  getDownloadPayment: (fromDate, toDate) =>
    `api/v1/downloadTransaction?fromDate=${fromDate ? fromDate : ''}&toDate=${
      toDate ? toDate : ''
    }`,

  getprivacybyid: id => `api/v1/static/privacy/${id}`,
  gettermsbyid: id => `api/v1/static/terms/${id}`,
  getfaqbyid: id => `api/v1/static/faq/${id}`,
  getbannerbyid: id => `api/v1/Banner/${id}`,
  getorderbyid: id => `api/v1/admin/getBookingById/${id}`,
  cancelorder: 'api/v1/admin/cancelBooking',
  getcontactdetailsbyid: id => `api/v1/getbyIdContactDetails/${id}`,
  getStaffbyid: id => `api/v1/profile/userById/${id}`,
  getPaymentbyid: id => `api/v1/TransactionUser/ById/${id}`,
  getsCancelbyid: id => `api/v1/static/CancelPolicy/${id}`,
  getsTimesheetbyid: id => `api/v1/admin/getStaffBookingById/${id}`,
  getStaffLocationLogs: (staffId, bookingId) =>
    `api/v1/admin/staffLocationLogs?staffId=${staffId}&bookingId=${bookingId}`,

  getCartbyid: id => `api/v1/admin/getCart/${id}`,

  addcategory: 'api/v1/admin/Category/addCategory',
  addsubcategory: 'api/v1/SubCategory/addSubcategory',
  addsubcategorychild: 'api/v1/SubCategory/addSubcategoryChild',
  addproduct: 'api/v1/Product/addProduct',
  addprivacy: 'api/v1/static/createPrivacy',
  addterms: 'api/v1/static/createTerms',
  addcancel: 'api/v1/static/createCancelPolicy',
  addfaq: 'api/v1/static/faq/createFaq',
  addbanner: 'api/v1/Banner',
  addcoupon: 'api/v1/admin/addCoupan',
  addcontactoffice: 'api/v1/addContactDetailsOffice',
  addcommision: 'api/v1/commission/add',
  addvideo: 'api/v1/admin/TrainingVideo/addTrainingVideo',
  sendNotification: 'api/v1/admin/notifications',
  addstaff: 'api/v1/profile/addStaff',
  addimage: 'api/v1/user/uploadImage',
  addtimesheet: 'api/v1/admin/createStaffBooking',
  addoutfit: 'api/v1/admin/Dress/addDress',
  addcheckout: id => `api/v1/admin/checkOut/${id}`,
  deletecart: id => `api/v1/admin/deleteCart/${id}`,

  addOrder: id => `api/v1/admin/addToCart/${id}`,
  addOrder1: id => `api/v1/admin/addOtherDetailsInCart/${id}`,

  addfund: id => `api/v1/admin/addRemoveMoney/${id}`,

  deletecategory: id => `api/v1/admin/Category/deleteCategory/${id}`,

  deletesubcategory: id => `api/v1/SubCategory/deleteSubcategory/${id}`,
  deletesubcategorychild: id => `api/v1/SubCategoryChild/deleteSubcategoryChild/${id}`,
  deleteproduct: id => `api/v1/Product/deleteProduct/${id}`,
  deleteprivacypolicy: id => `api/v1/static/privacy/${id}`,
  deleteterms: id => `api/v1/static/terms/${id}`,
  deletecancelpolicy: id => `api/v1/static/CancelPolicy/${id}`,
  deletefaq: id => `api/v1/static/faq/${id}`,
  deletebanner: id => `api/v1/Banner/${id}`,
  deletecoupon: id => `api/v1/admin/Coupan/${id}`,
  deletecontactdetails: id => `api/v1/DeleteContactDetails/${id}`,
  deletevideo: id => `api/v1/admin/TrainingVideo/deleteTrainingVideo/${id}`,
  deleteUser: id => `api/v1/profile/deleteUser/${id}`,
  deletedress: id => `api/v1/admin/Dress/deleteDress/${id}`,

  updatecategory: id => `api/v1/admin/Category/updateCategory/${id}`,
  updatesubcategory: id => `api/v1/SubCategory/updateSubcategory/${id}`,
  updateproduct: id => `api/v1/Product/updateProduct/${id}`,
  updatesubcategorychild: id => `api/v1/SubCategoryChild/updateSubcategoryChild/${id}`,
  updatecategorystatus: id => `api/v1/admin/Category/updateCategoryStatus/${id}`,
  updatesubcategorystatus: id => `api/v1/SubCategory/updateSubcategoryStatus/${id}`,
  updatesubcategorychildstatus: id =>
    `api/v1/SubCategoryChild/updateSubcategoryChildStatus/${id}`,
  updatefaqbyid: id => `api/v1/static/faq/${id}`,
  updatebannerbyid: id => `api/v1/Banner/${id}`,
  assignpartnerbyorderid: id => `api/v1/admin/assignStaffInBooking/${id}`,
  updatecontactdetails: id => `api/v1/updateContactDetails/${id}`,
  updatecontactdetailsOffice: id => `api/v1/updateContactDetailsOffice/${id}`,
  updateVideos: id => `api/v1/admin/TrainingVideo/updateTrainingVideo/${id}`,
  updateidpassword: id => `api/v1/profile/createUniqueIdForStaff/${id}`,
  updatedStaffById: id => `api/v1/profile/updateStaffProfile/${id}`,
  updatedTimesheetById: id => `api/v1/admin/editStaffBookingById/${id}`,
  approveStaffJob: id => `api/v1/admin/approveStaffJob/${id}`,
  updatedoutfitById: id => `api/v1/admin/Dress/updateDress/${id}`,

  newuserRecuitment: (page, limit, search, year, month) =>
    `api/v1/admin/getUsersByTypeAndDate?page=${page}&limit=${limit}&search=${
      search ? search : ''
    }&year=${year}&month=${month}`,
  absentuser: (page, limit, search) =>
    `admin/getUsersNotInAttendanceLastTwoMonths?page=${page}&limit=${limit}&search=${
      search ? search : ''
    }`,
  downloadabsentuser: 'api/v1/admin/downloadAbsentUsersLastTwoMonths',
  totalDeploymentDaily: 'api/v1/admin/totalDeploymentDaily',
  siteWiseAttendance: 'api/v1/admin/getSiteWiseAttendance',
  getEarlyCheckoutCount: 'admin/getEarlyCheckoutCount',
  getLateAttendanceCount: 'admin/getLateAttendanceCount',
  doubleDutyDaily: 'api/v1/admin/doubleDutyDaily',
  users: (page, limit, search) =>
    `api/v1/admin/getAllUser?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  getAllSiteReports: (page, limit, search, year, month) =>
    `api/v1/admin/getAllSiteReports?page=${page}&limit=${limit}&search=${
      search ? search : ''
    }&year=${year}&month=${month}`,
  getSiteReportById: id => `api/v1/admin/getSiteReportById/${id}`,
  updateVisitSiteReport: id => `admin/updateVisitSiteReport/${id}`,
  countUniqueSiteIds: 'admin/countUniqueSiteIds',
  getMonthlyDeployment: (page, limit, search, year, month) =>
    `api/v1/admin/getMonthlyDeployment?page=${page}&limit=${limit}&search=${
      search ? search : ''
    }&year=${year}&month=${month}`,

  getAllPendingRegularization: (page, limit, search) =>
    `admin/getAllPendingRegularization?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  updateRegularizationStatus: 'admin/updateRegularizationStatus',
  getAllManualAttendance: (page, limit, search) =>
    `admin/getAllManualAttendance?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  getAllSiteDetails: 'api/v1/admin/getAllSiteDetails',
  New_addSiteDetailsAdmin_new: 'api/v1/admin/addSiteDetailsAdmin',
  updateSiteDetails: id => `api/v1/admin/updateSiteDetails/${id}`,
  getSiteDetailsById: id => `api/v1/admin/getSiteDetailsById/${id}`,

  deleteSiteDetailsById: id => `api/v1/admin/deleteSiteDetailsById/${id}`,
  getUserById: id => `api/v1/admin/getUserById/${id}`,

  getAllUpdateRequests: (page, limit, search) =>
    `api/v1/admin/getAllUpdateRequests?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  approveUpdateProfile: 'api/v1/admin/approveUpdateProfile',
  rejectUpdateProfile: 'api/v1/admin/rejectUpdateProfile',
  getAllLeave: (page, limit, search) =>
    `api/v1/admin/getAllLeave?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  pushNotification: 'api/v1/admin/pushNotification',
  getSiteWiseDailyDeployment: (page, limit, search) =>
    `api/v1/admin/getSiteWiseDailyDeployment?page=${page}&limit=${limit}&search=${
      search ? search : ''
    }`,
  getEarlyCheckoutUsers: (page, limit, search) =>
    `admin/getEarlyCheckoutUsers?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  dailypresent: (page, limit, search) =>
    `api/v1/admin/getSiteWiseAttendance?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  doubleduty: (page, limit, search) =>
    `admin/getUsersWithMultipleAttendance?page=${page}&limit=${limit}&search=${
      search ? search : ''
    }`,
  getLateAttendances: (page, limit, search) =>
    `admin/getLateAttendances?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  getUsersBySiteId: id => `admin/getUsersBySiteId/${id}`,
  addUser: 'api/v1/admin/addUser',
  getAllUniqueSiteIds: (page, limit, search) =>
    `admin/getAllUniqueSiteIds?page=${page}&limit=${limit}&search=${search ? search : ''}`,
  getPreviousUserAddresses: id => `api/v1/profile/getallAddressByUserId/${id}`,
};

export default endPoints;
